<template>
    <v-card >
        <v-data-table
                :loading="loading"
                :page.sync="page"
                :items="items"
                :headers="headers"
                hide-default-footer
        >
            <template v-slot:item.type="{ item }">
                <span class="table-complete-name">{{work_type_formatter(item.type)}}</span>
            </template>


            <template v-slot:item.class_name="{ item }">
                <span class="table-complete-group_code">{{item.class_name.name}}</span>
            </template>

            <template v-slot:item.group="{ item }">
                <span class="table-complete-group_code">{{item.group.id}}</span>
            </template>

            <template v-slot:item.tutor="{ item }">
                <span class="table-complete-session">{{item.tutor.name}}</span>
            </template>
            <template v-slot:item.subject="{ item }">
                <span class="table-complete-session">{{item.subject.name}}</span>
            </template>




            <template v-slot:item.action="{ item }">
                 <router-link classes="profile-link" active-classes :exact="true" :to="{name: 'EditWork',params:{id:item.work_id}}">
                    <v-icon color="success" v-if="permitObj.work_edit">mdi-file-edit</v-icon>
                 </router-link>
                <v-icon color="red" @click.stop="confirmDelete(item)" v-if="permitObj.work_delete">mdi-delete</v-icon>
            </template>
        </v-data-table>
        <div class="pa-2 d-flex justify-end">
      <span class="pa-2">
        Total Works
        <span
                :style="{'color':this.$vuetify.theme.themes.light.primary}"
        >{{count}}</span>
      </span>
            <v-spacer></v-spacer>
            <v-pagination circle v-model="page" :length="totalPages"></v-pagination>
        </div>

         <delete-dialog @success="deleteWork" :confirm-loading="deleteConfirmLoading" @closeDialog="cancelDelete"  :dialog="delete_dialog" title="Work"></delete-dialog>
    </v-card>
</template>

<script>
    import DataTableMixin from "../../mixins/dataTable";
    import DeleteDialog from "../Dialogs/DeleteDialog";
    import DeleteRow from "../../mixins/deleteRow";
import { getPermitObjects } from '../../utils/allowedPermissions';

    export default {
        name: "WorkTable",
        components: {DeleteDialog},
        mixins:[
            DataTableMixin,
            DeleteRow
        ],
        data() {
            return {
                loading:true,
                dialog: false,
                page: 1,
                pageCount: 3,
                itemsPerPage: 10,
                permitObj: {},
                headers: [
                    {text: "Srno.", sortable: true, value: "work_id"},
                    {text: "Name", value: "work_name", value: "work_name"},
                    {text: "Group", sortable: true, value: "group.group_name"},
                    // {text: "Subject", value: "subject", sortable: false},
                    // {text: "Tutor Name", value: "tutor", sortable: true},
                    {text: "Type", value: "work_type", sortable: true},
                    {text: "Action", value: "action", sortable: false}
                ],
            };
        },
        methods: {
            deleteWork(){
                this.deleteConfirmLoading=true
                axios.delete(apiRoutes.work.url+'/'+this.current_row.work_id).then(response=>{
                    // console.log(response)
                    this.getItems()
                    this.deleteConfirmLoading=false
                    this.delete_dialog=false
                }).catch(error=>{

                })
            },
            getZeroAddedNum(num) {
                return num.toString().padStart(2, "0");
            },
            getItems(){
                this.loading=true
                axios.get(apiRoutes.work.url,{
                    params:this.formQueryParams()
                }).then(response=>{
                    this.loading=false
// console.log(response.data)
                    this.formalizeTable(response.data)
                })
            },
            getPermittedArray() {
                let links = this.$store?.getters?.permissions;
                let pathName = "Works";
                this.permitObj = getPermitObjects(links, pathName);
            }
        },
        mounted() {
            this.loading=false
            // console.log('ss')
            this.getItems()
            this.getPermittedArray()
        },
    };
</script>

<style lang="scss">
    .v-data-table-header th span {
        font: 300 14px Gotham;
        font-family: "Gotham Narrow";
        color: #8898aa;
    }

    .table-complete {
        &-srno {
            font: 500 14px/13px Gotham;
            color: #172b4d;
        }

        &-name {
            display: block;
            font: 500 14px/13px Gotham;
            color: #6a158e;
        }

        &-group_code {
            font: 500 14px/13px Gotham;
            color: #0ebddff7;
        }

        &-time {
            display: block;
            font: 400 14px/10px Gotham;
            color: #0e0edff7;
        }

        &-days {
            font: 400 14px/15px Gotham;
            color: #172b4db3;
        }

        &-session {
            font: 500 14px/13px Gotham;
            color: #f0cb00;
        }
    }
</style>